import type { ApiResource } from './schema';
import { resource as tickets } from './resources/tickets';
import { resource as devices } from './resources/devices';
import { resource as security } from './resources/security';
import { resource as crm } from './resources/crm';
import { resource as docs } from './resources/docs';
import { resource as invoices } from './resources/invoices';
import { resource as scripts } from './resources/scripts';
import { resource as automations } from './resources/automations';
import { resource as backups } from './resources/backups';
import { resource as ai } from './resources/ai';
import { resource as usersPermissions } from './resources/users-permissions';
import { resource as notifications } from './resources/notifications';
import { resource as community } from './resources/community';
import { resource as complianceGrc } from './resources/compliance-grc';
import { resource as billingOps } from './resources/billing-ops';
import { resource as rmmManagement } from './resources/rmm-management';
import { resource as networkIpam } from './resources/network-ipam';
import { resource as authTenancy } from './resources/auth-tenancy';
import { resource as vaultMailbox } from './resources/vault-mailbox';

// One file per resource (src/data/resources/*.ts), merged here — same content-as-data pattern
// as community/nexusrmm-wiki/src/content/sections/index.ts, and for the same reason: many small
// independently-owned files instead of one growing monolith.
export const RESOURCES: ApiResource[] = [
  tickets,
  devices,
  security,
  crm,
  docs,
  invoices,
  scripts,
  automations,
  backups,
  ai,
  usersPermissions,
  notifications,
  community,
  complianceGrc,
  billingOps,
  rmmManagement,
  networkIpam,
  authTenancy,
  vaultMailbox,
];
